import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { languagePath } from "@/site";

const LanguageContext = createContext({ lang: "en", tx: (en) => en });
export const LanguageProvider = ({ children }) => {
  const { pathname } = useLocation();
  const { lang } = languagePath(pathname);
  const value = useMemo(() => ({ lang, tx: (en, tr) => lang === "tr" ? tr : en }), [lang]);
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
export const useLang = () => useContext(LanguageContext);
